<template>
    <div>
        <div :id="'sec-' + section.name.replaceAll(' ', '-')" v-if="faq.withSections">
            <cUtilsEdit @edit="goToSectionField(section.id, 'sectionName')">
                <h4
                    :style="{
                        color: faq.questionColor,
                        'font-size': +faq.questionSize + 2 + 'px',
                    }"
                    class="text-2xl font-semibold"
                    :class="[
                        faq.textAlign === 'right'
                            ? 'text-right'
                            : faq.textAlign === 'center'
                              ? 'text-center'
                              : 'text-left',
                    ]"
                >
                    {{ section.name }}
                </h4>
            </cUtilsEdit>
        </div>
        <dl class="md:grid md:grid-cols-2 md:gap-8">
            <ColumnsQuestion
                v-for="question in questionsToShow"
                :key="question.id"
                :faq="faq"
                :question="question"
                :query="query"
            />
        </dl>
    </div>
</template>

<script>
import cUtilsEdit from "@/views/shared/cUtilsEdit.vue";
import { useFaqGoTo } from "@/views/tools/faq/utils/useFaqGoTo";
import ColumnsQuestion from "./ColumnsQuestion.vue";

export default {
    name: "ColumnsSection",
    props: {
        faq: Object,
        section: Object,
        query: String,
    },
    setup() {
        const { goToSectionField } = useFaqGoTo();
        return {
            goToSectionField,
        };
    },
    components: {
        cUtilsEdit,
        ColumnsQuestion,
    },
    computed: {
        questionsToShow() {
            const questions = this.section.questions.filter((x) => !x.hide && !x._deleted);
            if (this.query) {
                return questions.filter(
                    (item) =>
                        item.question.toLowerCase().includes(this.query.toLowerCase()) ||
                        item.answer.toLowerCase().includes(this.query.toLowerCase())
                );
            }
            return questions;
        },
    },
};
</script>
